import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Helper function to get public URL for images stored in Supabase Storage
 * @param {string} bucket - The storage bucket name (e.g., 'product-images', 'banners')
 * @param {string} path - The file path within the bucket
 * @returns {string|null} The public URL or null if path is not provided
 */
export const getPublicImageUrl = (bucket, path) => {
  if (!path) return null;
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
};

/**
 * Extrae el path de un archivo desde su URL pública de Supabase
 * @param {string} url - URL pública de la imagen
 * @param {string} bucket - Nombre del bucket
 * @returns {string|null} - El path del archivo o null
 */
export const extractPathFromUrl = (url, bucket) => {
  if (!url || typeof url !== 'string') return null;
  
  const baseUrlPart = `/storage/v1/object/public/${bucket}/`;
  const index = url.indexOf(baseUrlPart);
  if (index === -1) return null;
  
  let path = url.substring(index + baseUrlPart.length);
  if (path.includes('?')) {
    path = path.split('?')[0];
  }
  
  return path;
};
